export default "__VITE_ASSET__1GXDf9QA__"